import { useEffect } from 'react';
import SplashScreenComponent from './Components/SplashScreen';
import RealTimeClient from './Services/RealTimeClient';
import { appDebugLog } from './Util/appDebugLog';
import './App.scss';

function App() {
  useEffect(() => {
    return () => {
      appDebugLog('App unmounting - cleaning up RealTimeClient');
      RealTimeClient.cleanup();
    };
  }, []);

  return (
    <div className="App">
      <SplashScreenComponent />
    </div>
  );
}

export default App;
